const ROS_GRID_COLUMNS = "300px 1fr";

export { ROS_GRID_COLUMNS };
